import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {DocumentResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {DocumentStatusPill} from 'src/pages/Modules/DocumentManagement/documentReviewHelpers';

export interface UseDocumentVersionsColumnsOptions {
  /** Include the review Status column — gated by the DocumentReviews feature flag. */
  showStatusColumn?: boolean;
}

export const useDocumentVersionsColumns = (
  options?: UseDocumentVersionsColumnsOptions
) => {
  const showStatusColumn = options?.showStatusColumn ?? false;

  const columns = useMemo<MRT_ColumnDef<DocumentResponse>[]>(() => {
    const baseColumns: MRT_ColumnDef<DocumentResponse>[] = [
      {
        accessorKey: 'name',
        header: 'File Name',
      },
      {
        accessorKey: 'summaryDescription',
        header: 'Summary',
      },
      {
        accessorKey: 'creatorName',
        header: 'Created By',
      },
      {
        accessorKey: 'updatedAt',
        header: 'Update Date',
        Cell: ({cell}) => (
          <>{cell.getValue<string | undefined>()?.toShortDate()}</>
        ),
      },
      {
        accessorKey: 'createdAt',
        header: 'Created Date',
        Cell: ({cell}) => (
          <>{cell.getValue<string | undefined>()?.toShortDate()}</>
        ),
      },
      {
        accessorKey: 'version',
        header: 'Version',
      },
    ];

    if (showStatusColumn) {
      baseColumns.push({
        accessorKey: 'status',
        header: 'Status',
        Cell: ({row}) => {
          const pill = DocumentStatusPill(row.original.status);
          return pill ? <Pill {...pill} /> : null;
        },
      });
    }

    return baseColumns;
  }, [showStatusColumn]);

  return columns;
};
